import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ClientAuthService } from '../../services/auth/client-auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-logged-out',
    templateUrl: './logged-out.component.html',
    styleUrls: ['./logged-out.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoggedOutComponent {
  constructor(private _authService: ClientAuthService, private _router: Router) { }
  
  ngOnInit(): void {
    
  }
}
